if (!customElements.get("subscription-quick-add")) {
  class SubscriptionQuickAdd extends HTMLElement {
    static openDropdowns = new Set();
    static globalListenerAttached = false;

    constructor() {
      super();
      this.triggerBtn = this.querySelector(".product-card__action-button");
      this.content = this.querySelector(".subscription-quick-add-content");
      this.container = this.querySelector(".subscription-quick-add-container");
      this.form = this.querySelector(".subscription-quick-add__form");
      this.submitBtn = this.querySelector(".subscription-submit-btn");

      this.activateDropdown = this.activateDropdown.bind(this);
      this.handleFormSubmit = this.handleFormSubmit.bind(this);
      this.handlePlanUpdate = this.handlePlanUpdate.bind(this);
      this.isClosed = true;

      SubscriptionQuickAdd.attachGlobalListener();
    }

    static attachGlobalListener() {
      if (!SubscriptionQuickAdd.globalListenerAttached) {
        document.addEventListener(
          "click",
          SubscriptionQuickAdd.handleGlobalClick
        );
        SubscriptionQuickAdd.globalListenerAttached = true;
      }
    }

    static handleGlobalClick(event) {
      SubscriptionQuickAdd.openDropdowns.forEach((dropdown) => {
        if (!dropdown.contains(event.target)) {
          dropdown.closeDropdown();
        }
      });
    }

    connectedCallback() {
      this.triggerBtn.addEventListener("click", this.activateDropdown);
      if (this.form) {
        this.form.addEventListener("submit", this.handleFormSubmit);
      }

      if (this.submitBtn && !this.submitBtn.dataset.originalText) {
        this.submitBtn.dataset.originalText = this.submitBtn.textContent;
      }

      this.addEventListener("skio::update-selling-plan", this.handlePlanUpdate);
    }

    disconnectedCallback() {
      this.triggerBtn.removeEventListener("click", this.activateDropdown);
      if (this.form) {
        this.form.removeEventListener("submit", this.handleFormSubmit);
      }
      SubscriptionQuickAdd.openDropdowns.delete(this);
      this.removeEventListener(
        "skio::update-selling-plan",
        this.handlePlanUpdate
      );
    }

    handlePlanUpdate(event) {
      if (!event.detail.formattedPrice) return;

      this.submitBtn.textContent = `${FoxTheme.subscriptionStrings.quickBuy} - ${event.detail.formattedPrice}`;
      this.triggerBtn.textContent = `${FoxTheme.subscriptionStrings.quickBuy} - ${event.detail.formattedPrice}`;
    }

    activateDropdown(event) {
      event.stopPropagation();

      if (this.isClosed) {
        SubscriptionQuickAdd.openDropdowns.forEach((dropdown) => {
          if (dropdown !== this) {
            dropdown.closeDropdown();
          }
        });

        this.triggerBtn.classList.add("subscription-dropdown-active");
        this.content.style.maxHeight = this.container.scrollHeight + 4 + "px";
        this.isClosed = false;

        SubscriptionQuickAdd.openDropdowns.add(this);
      } else {
        this.closeDropdown();
      }
    }

    closeDropdown() {
      this.triggerBtn.classList.remove("subscription-dropdown-active");
      this.content.style.maxHeight = "0px";
      this.isClosed = true;

      SubscriptionQuickAdd.openDropdowns.delete(this);
    }

    async handleFormSubmit(event) {
      event.preventDefault();

      if (this.submitBtn) {
        this.submitBtn.disabled = true;
        this.submitBtn.textContent = FoxTheme.subscriptionStrings.adding;
      }

      try {
        const formData = new FormData(this.form);
        const productData = {
          items: [
            {
              id: formData.get("id"),
              quantity: 1,
            },
          ],
        };

        const sellingPlan = formData.get("selling_plan");
        if (sellingPlan && sellingPlan !== "") {
          productData.items[0].selling_plan = sellingPlan;
        }

        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(productData),
        });

        if (response.ok) {
          this.closeDropdown();

          fetch(`${FoxTheme.routes.cart_url}`, {
            ...FoxTheme.utils.fetchConfig(),
          })
            .then((cartResponse) => cartResponse.json())
            .then((cartJson) => {
              FoxTheme.pubsub.publish(
                FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
                { cart: cartJson }
              );
            })
            .catch((error) => {
              console.error("Error fetching cart state:", error);
            });

          const cartDrawer = document.querySelector("cart-drawer");
          if (cartDrawer) {
            document.dispatchEvent(
              new CustomEvent("cart:refresh", {
                detail: { open: true },
              })
            );
          } else {
            window.location.href = "/cart";
          }
        } else {
          console.error("Failed to add product to cart");
          this.form.submit();
        }
      } catch (error) {
        console.error("Error adding product to cart:", error);
        this.form.submit();
      } finally {
        if (this.submitBtn) {
          this.submitBtn.disabled = false;
          this.submitBtn.textContent =
            this.submitBtn.dataset.originalText ||
            this.submitBtn.textContent.replace(
              FoxTheme.subscriptionStrings.adding,
              FoxTheme.subscriptionStrings.quickBuy
            );
        }
      }
    }
  }

  customElements.define("subscription-quick-add", SubscriptionQuickAdd);
}
